<div class="row password-strengh-dashes">
    <div class=" point" [style.background-color]="bar0">

    </div>
    <div class=" point" [style.background-color]="bar1">

    </div>
    <div class=" point" [style.background-color]="bar2">

    </div>
    <div class=" point" [style.background-color]="bar3">

    </div>

</div>
<div class="row">
    <p [style.color]="messageColor" *ngIf="passwordToCheck?.length">{{ message }}</p>

</div>

<div class="row">
    <div class="PasswordMustContain"
        style="color: black; font-size: 14px; font-family: Roboto; font-weight: 500; line-height: 24px; letter-spacing: 0.17px; word-wrap: break-word">
        Password must contain</div>
</div>

<div class="row">
    <ul style="padding-left: 0rem;">
        <li>

            <div class="icon-label">
                <mat-icon *ngIf="!hasNumbers" class="icon-validationPwRed">close</mat-icon>
                <mat-icon *ngIf="hasNumbers" class="icon-validationPw">check</mat-icon>
                <div class="password-contain-text">1 or more numbers (0-9)</div>
            </div>
        </li>
        <li>
            <div class="icon-label">
                <mat-icon *ngIf="!haslowerLetters" class="icon-validationPwRed">close</mat-icon>
                <mat-icon *ngIf="haslowerLetters" class="icon-validationPw">check</mat-icon>
                <div class="password-contain-text">1 or more letters (a-z , A-Z)</div>
            </div>
        </li>
        <li>
            <div class="icon-label">
                <mat-icon *ngIf="!hasSymbols" class="icon-validationPwRed">close</mat-icon>
                <mat-icon *ngIf="hasSymbols" class="icon-validationPw">check</mat-icon>
                <div class="password-contain-text">1 special character</div>
            </div>
        </li>
        <li>
            <div class="icon-label">
                <mat-icon *ngIf="passwordToCheck.length < 10 || passwordToCheck.length > 20"
                    class="icon-validationPwRed">close</mat-icon>
                <mat-icon *ngIf="passwordToCheck.length >= 10 && passwordToCheck.length <= 20"
                    class="icon-validationPw">check</mat-icon>
                <div class="password-contain-text">10 characters minimum and 20 maximum</div>
            </div>
        </li>
    </ul>
</div>